export const CHECK_READY_BACKEND = 'checkReadyBackend';
export const FINISH_READY_BACKEND = 'finishReadyBackend';

export const CALL_NAVIGATION = 'callNavigation';
export const FINISH_NAVIGATION = 'finishNavigation';
